if (!customElements.get('home-product-card')) {
  customElements.define('home-product-card', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', (event) => {
        if (event.target.matches('select[name="id"]')) this.updateVariant();
      });
    }

    connectedCallback() {
      this.updateVariant();
    }

    updateVariant() {
      const select = this.querySelector('select[name="id"]');
      const button = this.querySelector('[type="submit"]');
      if (!select || !button) return;

      const option = select.selectedOptions[0];
      const selected = Boolean(option?.value);
      const available = selected && option.dataset.available === 'true';
      button.disabled = !available;
      const soldOut = selected ? !available : this.dataset.productAvailable === 'false';
      this.querySelector('[data-add-label]').textContent = soldOut ? this.dataset.soldOutLabel : this.dataset.addLabel;
      if (!selected) return;

      this.querySelector('[data-card-price]').textContent = option.dataset.price;
      this.querySelector('product-form')?.handleErrorMessage?.();
      this.querySelectorAll('[data-product-link]').forEach((link) => { link.href = option.dataset.url; });
      const image = this.querySelector('[data-card-image]') || this.querySelector('.md-home-products__product-image');
      if (image && option.dataset.image) {
        image.src = option.dataset.image;
        image.removeAttribute('srcset');
        image.alt = option.dataset.imageAlt;
      }
    }
  });
}
